import { render, staticRenderFns } from "./studentPatients.vue?vue&type=template&id=1cbdd1fb&scoped=true"
import script from "./studentPatients.vue?vue&type=script&lang=js"
export * from "./studentPatients.vue?vue&type=script&lang=js"
import style0 from "./studentPatients.vue?vue&type=style&index=0&id=1cbdd1fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cbdd1fb",
  null
  
)

export default component.exports